export const REGION_TYPES = Object.freeze({
    STAGING : "online",
    NET : "net",
    UK : "uk",
});